import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DtoPoint from '../../../dto/DtoPoint'
import DtoStation from '../../../../sites/dto/DtoStation'
import DtoKeyFigures from '../../../../sites/dto/DtoKeyFigures'
import { filter, find, intersectionWith, minBy, range, flatten } from 'lodash'
import ReactEcharts from 'echarts-for-react'
import { getYear } from '../../../../utils/DateUtil'
import SiteTypes from '../../../../utils/mapUtils/SiteTypes'
import i18n from 'simple-react-i18n'
import moment from 'moment'
import DtoSiteType from '../../../../referential/dto/DtoSiteType'

class PointProximityChart extends Component {

	constructor(props) {
		super(props)
	}

	getNbData = (keyFigures) => {
		//TODO Get key figures from type
		switch (this.props.siteType.parameter) {
			case SiteTypes.QUALITOMETER.type:
			case SiteTypes.QUALITOMETER_SURFACE.type:
				return keyFigures.nbAnalysis
			default:
				return keyFigures.nbMeasure
		}
	}

	createTabData = (value, keyFigures) => {
		const station = value.station
		const stationKeyFigures = find(keyFigures, (b) => {
			return b.stationId == station.id
		})
		if (stationKeyFigures) {
			const distance = value.distance
			const nbData = this.getNbData(stationKeyFigures)
			const name = station.name
			return {
				id: station.id,
				typeId: station.typeId,
				distance: distance,
				nbData: nbData,
				name: name
			}
		}
		return null
	}


	getData = () => {
		const keyFigures = intersectionWith(this.props.keyFigures, this.props.proximityStation, (a, b) => {
			if (b.station) {
				return a.stationId == b.station.id && a.typeId == this.props.siteType.id && a.endDate
			}
			return null
		})
		if (keyFigures && keyFigures.length) {
			const minYear = getYear(minBy(keyFigures, 'endDate').endDate)
			const rangeYear = range(minYear, getYear(moment().add(1, 'year'))).reverse()
			return flatten(rangeYear.map((o) => {
				const keyFiguresSelected = filter(keyFigures, (keyFigure) => {
					return getYear(keyFigure.endDate) == o
				})
				if (keyFiguresSelected && keyFiguresSelected.length) {
					const stations = intersectionWith(this.props.proximityStation, keyFiguresSelected, (a, b) => {
						return a.station.id == b.stationId
					})
					return stations.map((b) => {
						return this.createTabData(b, keyFigures)
					}).map((a) => {
						return [a.distance, o, a.nbData, a.name]
					})
				}
				return [[null, o]]
			}))
		}
		return null
	}

	getStationData = () => {
		if (this.props.pointKeyFigures.length) {
			const keyFigure = find(this.props.pointKeyFigures, (o) => {
				return o.typeId == this.props.siteType.id
			})
			if (keyFigure) {
				const year = Number(getYear(keyFigure.endDate))
				return [[0, year, this.getNbData(this.props.pointKeyFigures[0]), this.props.point.name]]
			}
			return []
		}
		return []
	}
	getLabel = () => {
		return {
			emphasis: {
				show: true,
				formatter: function (param) {
					return param.data[3] + ' - ' + param.data[2]
				},
				color: 'black',
				position: 'top'
			}
		}
	}

	getTitle = () => {
		return i18n.proximityPoints + ' de type : ' + SiteTypes[this.props.point.typeParameter].name(0)
	}

	getOption = () => {
		const data = this.getData()
		if (data && data.length) {
			const stationData = this.getStationData()
			return {
				xAxis: {
					name: i18n.distance + ' (en km)',
					scale: true
				},
				padding: 0,
				yAxis: {
					name: i18n.dataHistory,
					type: 'category',
					scale: true
				},
				toolbox: {
					show: true,
					feature: {
						myTool2: {
							show: true,
							title: i18n.fullScreen,
							icon: 'image://https://www.aquasys.fr/wp-content/uploads/2018/04/Antu_view-fullscreen.svg_.png',
							onclick: function () {
								$('#proximityChart').toggleClass('fullscreen-chart')
								$('#proximityChartContent').toggleClass('fullscreen-chart')
							},
							iconStyle: {}
						},
						dataZoom: {
							yAxisIndex: 'none',
							title: i18n.customZoom
						},
						restore: {
							title: i18n.restore
						},
						saveAsImage: {
							title: i18n.exportFunction
						}
					}
				},
				dataZoom: [
					{
						show: true,
						realtime: true,
						bottom: -2
					}
				],
				series: [{
					data: data,
					type: 'scatter',
					symbolSize: function (d) {
						return Math.sqrt(d[2]) * 0.95
					},
					label: this.getLabel()
				}, {
					type: 'effectScatter',
					symbolSize: function (d) {
						return Math.sqrt(d[2]) * 0.95
					},
					data: stationData,
					label: this.getLabel()
				}]
			}
		}
		return null
	}

	render() {
		const options = this.getOption()
		if (options) {
			return (
				<div className='row no-margin card' id='proximityChart'>
                    <div className='card-padding'>
    					<div className='card-title no-padding no-margin-bottom'>
    						<h6 className='aquadb-title'>{ this.getTitle() }</h6>
    					</div>
    					<div className='card-content no-padding' id='proximityChartContent'>
    						<ReactEcharts option={ this.getOption() }
    							notMerge={ true }
    							lazyUpdate={ true }
    							style={ { height: '500px' } } />
    					</div>
                    </div>
				</div>
			)
		}
		return null
	}
}

PointProximityChart.propTypes = {
	point: PropTypes.objectOf(DtoPoint),
	siteType: PropTypes.objectOf(DtoSiteType),
	proximityStation: PropTypes.shape(PropTypes.objectOf({
		distance: PropTypes.number,
		station: PropTypes.instanceOf(DtoStation)
	})),
	pointKeyFigures: PropTypes.arrayOf(PropTypes.objectOf(DtoKeyFigures)),
	keyFigures: PropTypes.arrayOf(PropTypes.objectOf(DtoKeyFigures))
}
const mapStateToProps = store => {
	return {
		point: store.PointReducer.point,
		pointKeyFigures: store.PointReducer.pointKeyFigures,
		keyFigures: store.SitesReducer.keyFigures
	}
}

export default connect(mapStateToProps)(PointProximityChart)



// WEBPACK FOOTER //
// ./src/point/components/proximity/charts/PointProximityChart.js